import { isRubiaGallegaExperienceLive } from '@/lib/experienceLaunch';
import { useEffect, useState } from 'react';

export function useRubiaGallegaExperience() {
  const [isLive, setIsLive] = useState(() => isRubiaGallegaExperienceLive());

  useEffect(() => {
    const sync = () => setIsLive(isRubiaGallegaExperienceLive());
    sync();

    const intervalId = window.setInterval(sync, 60_000);
    return () => window.clearInterval(intervalId);
  }, []);

  return isLive;
}
